import Content from '@/layout/content';
import Layout from '@/layout';

export default {
  path: '/ciae-rms',
  component: window.name ? Content : Layout,
  meta: {
    title: '首页',
    icon: 'iconfont icon-home',
    code: '01020101'
  },
  children: [
    {
      path: '',
      name: 'ciaeRms',
      component: () => import('@/views/ciaeRms'),
      meta: {
        activeMenu: '/ciae-rms'
      }
    },
    {
      path: '*',
      component: () => import('@/views/404')
    }
  ]
};
